import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const entryInfoWrapper = style({
  display: "grid",
  gap: vars.space.m,
});

export const entryInfoPanel = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  color: vars.colors.onSurface,
});

export const entryInfoPanelHeading = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const dataList = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  color: vars.colors.onSurface,
});

export const dataListItem = style({
  display: "flex",
  alignItems: "center",
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.body.l,
});

export const dataListHeading = style({
  flex: "1 0 65%",
  lineHeight: "inherit",
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.regular,
});

export const dataListValue = style({
  flex: "1 0 35%",
  textAlign: "end",
  fontFamily: vars.fonts.bold,
});

export const footnote = style({
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.body.s,
});
